import React from "react";
import "./Template_3.css";

const Template_3_Footer = () => {
  return (
    <footer id="contact" className="Template_3 footer">
      <div className="Template_3 container">
        <div className="Template_3 footer-content">
          <div className="Template_3 footer-column">
            <h3>WanderLux</h3>
            <p>
              Delivering bespoke luxury travel experiences with unparalleled
              service and attention to detail.
            </p>
            <div className="Template_3 social-links">
              <a href="#">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="Template_3 footer-column">
            <h3>Destinations</h3>
            <ul>
              <li>
                <a href="#">Monaco</a>
              </li>
              <li>
                <a href="#">St. Tropez</a>
              </li>
              <li>
                <a href="#">Kyoto</a>
              </li>
              <li>
                <a href="#">Venice</a>
              </li>
              <li>
                <a href="#">Aspen</a>
              </li>
            </ul>
          </div>

          <div className="Template_3 footer-column">
            <h3>Navigation</h3>
            <ul>
              <li>
                <a href="#">About</a>
              </li>
              <li>
                <a href="#">Terms</a>
              </li>
              <li>
                <a href="#">FAQ</a>
              </li>
              <li>
                <a href="#">Privacy</a>
              </li>
              <li>
                <a href="#">Refunds</a>
              </li>
              <li>
                <a href="#">Contact</a>
              </li>
            </ul>
          </div>

          <div className="Template_3 footer-column">
            <h3>Contact</h3>
            <ul>
              <li>
                <i className="fas fa-phone"></i> +1 (555) 987-6543
              </li>
              <li>
                <i className="fas fa-envelope"></i> concierge@wanderlux.com
              </li>
              <li>
                <i className="fas fa-map-marker-alt"></i> 456 Elite Ave, Luxury
                City
              </li>
            </ul>
          </div>
        </div>

        <div className="Template_3 copyright">
          <p>&copy; 2023 WanderLux. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Template_3_Footer;
